/**
 * 日時ユーティリティクラス
 */
export default class DateTimeUtils {
    /** インスタンス */
    private static _instance: DateTimeUtils

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new DateTimeUtils();
        }
        return this._instance;
    }

    /**
     * 現在の日時を取得する
     */
    private now() {
        const now = new Date()
        /* ISO書式で日本時間になるように時間をずらす */
        now.setTime(now.getTime() + 1000 * 60 * 60 * 9)
        return now
    }

    /**
     * 現在の日時を取得する
     */
    public getNowTime() {
        return this.now().getTime()
    }

    /**
     * 現在の日時(yyyy-MM-dd HH:mm:ss)を取得する
     */
    public getNow() {
        return this.now().toISOString().substr(0, 19)
    }

    /**
     * 日付書式(yyyy/MM/dd HH:mm:ss)で取得する
     * @param dateTime yyyy-MM-dd HH:mm:ss形式
     */
    public toJapanFormat(dateTime: string) {
        return dateTime.replace(/-/g, "/").replace(/T/g, " ").replace(/Z/g, "").substr(0, 19)
    }

    /**
     * 日付書式(yyyy/MM/dd HH:mm:ss)で取得する
     * @param dateTime yyyy-MM-dd HH:mm:ss形式
     */
    public toISOFormat(dateTime: string) {
        return dateTime.replace(/\//g, "-")
    }

    /**
     * 現在日時を指定書式で取得する
     * @param format 
     */
    public format(format: string) {
        const dateTime = this.getNow()
        const yyyy = dateTime.substr(0, 4)
        const yy = dateTime.substr(2, 2)
        const mm = dateTime.substr(5, 2)
        const dd = dateTime.substr(8, 2)
        const hh = dateTime.substr(11, 2)
        const mi = dateTime.substr(14, 2)
        const ss = dateTime.substr(17, 2)
        return format.replace("yyyy", yyyy)
                    .replace("yy", yy)
                    .replace("MM", mm)
                    .replace("dd", dd)
                    .replace("HH", hh)
                    .replace("mm", mi)
                    .replace("ss", ss)
    }

    /**
     * 指定時間ずらず
     * @param dateTime yyyy-MM-dd HH:mm:ss形式
     */
    public atOffset(dateTime: string, offset: number) {
        const dt = new Date(dateTime)
        dt.setTime(dt.getTime() + 1000 * 60 * 60 * offset)
        return dt.toISOString().substr(0, 19)
    }

    /**
     * 標準時間を日本時間にする
     * @param dateTime yyyy-MM-dd HH:mm:ss形式
     */
    public toJST(dateTime: string) {
        return this.atOffset(dateTime, 9)
    }
}
